import { render, staticRenderFns } from "./annex.vue?vue&type=template&id=3dd0e383&scoped=true&"
import script from "./annex.vue?vue&type=script&lang=ts&"
export * from "./annex.vue?vue&type=script&lang=ts&"
import style0 from "./annex.vue?vue&type=style&index=0&id=3dd0e383&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd0e383",
  null
  
)

export default component.exports